var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"object-contain p-2 rounded-full flex items-center justify-center",class:_vm.componentClass},[_vm._v(" "+_vm._s(_vm.formattedLetter)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }